import _ from "lodash";
import ls from "local-storage";
import Axios from 'axios';

const savePaymentsSmartList = async customs => {
    try {
        await Axios.post('/userclientconfigurations', {
            Name: 'payment-smart-list',
            JsonData: JSON.stringify({
                smartList: customs
            })
        });
    } catch (error) {
        console.error('Save Payment Smart List Error => ', error);
    }
};

const PaymentFiltersReducer = (state, action) => {
    switch (action.type) {
        case "PaymentsFiltersChangeActiveSet":
            ls.set("nw_config_paymentwallfilter", {
                ...state,
                activeSet: action.newActiveSet,
                filterType: action.filterType
            });
            return {
                ...state,
                activeSet: action.newActiveSet,
                filterType: action.filterType
            };
        case "PaymentsFiltersAddCustomSet":
            const customSetCopy = [...state.customSets];
            customSetCopy.push(action.newSet);
            const data = {
                ...state,
                customSets: customSetCopy,
                activeSet: action.newSet.id
            }
            ls.set("nw_config_paymentwallfilter", data);

            let smartList = [...data.customSets];

            savePaymentsSmartList(smartList);
            return {
                ...state,
                customSets: customSetCopy,
                activeSet: action.newSet.id
            };
        case "PaymentsFiltersEditCustomSet":
            let customSetCopy2 = state.customSets.filter(
                el => el.id !== action.newSet.id
            );
            action.newSet.id = Date.now();
            customSetCopy2.push(action.newSet);
            const editData = {
                ...state,
                customSets: customSetCopy2,
                activeSet: action.newSet.id
            };

            ls.set("nw_config_paymentwallfilter", editData);

            let editSmartList = editData.customSets

            savePaymentsSmartList(editSmartList);
            return {
                ...state,
                customSets: customSetCopy2,
                activeSet: action.newSet.id
            };
        case "PaymentsFiltersCloneSet":
            const copyOfActive = _.cloneDeep(action.activeSet);
            copyOfActive.id = Date.now();
            copyOfActive.fixed = false;
            copyOfActive.name = copyOfActive.name + "(copy)";
            const copyOfCustomSets = [...state.customSets];
            copyOfCustomSets.push(copyOfActive);

            const cloneData = {
                ...state,
                customSets: copyOfCustomSets,
                activeSet: copyOfActive.id
            };

            ls.set("nw_config_paymentwallfilter", cloneData);

            let cloneSmartList = [...cloneData.customSets];

            savePaymentsSmartList(cloneSmartList);
            return {
                ...state,
                customSets: copyOfCustomSets,
                activeSet: copyOfActive.id
            };
        case "PaymentsFiltersDeleteSet":
            const newCustomSets = [...state.customSets].filter(
                el => el.id !== action.activeSet
            );
            const deleteData = {
                ...state,
                customSets: newCustomSets,
                activeSet: 'v0'
            };

            ls.set("nw_config_paymentwallfilter", deleteData);

            let deleteSmartList = [...deleteData.customSets];

            savePaymentsSmartList(deleteSmartList);
            return {
                ...state,
                customSets: newCustomSets,
                activeSet: 'v0'
            };
        case "PaymentsFiltersSaveCustomSets":
            let newFilterData = { ...state, customSets: action.customSets };

            ls.set("nw_config_paymentwallfilter", newFilterData);

            return newFilterData;
        default:
            return state;
    }
};

export default PaymentFiltersReducer;
